import React from 'react'
import '../styles/geist-fonts.css'

interface LogisticWrapperProps {
  children: React.ReactNode
}

/**
 * Wrapper component que aplica las fuentes Geist localmente
 * solo a los módulos de logística sin afectar la configuración global
 */
export default function LogisticWrapper({ children }: LogisticWrapperProps) {
  return <div className="logistics-body min-h-screen">{children}</div>
}
